import { RESPONSE_VARIABLE_LABELS } from "./analyticsConstants";

// Derives which sections/labels to show from the backend's detected design
// type (chartData._design, set by AnalysisEngine.detect_design_type()) --
// this reflects the data actually generated, rather than a config field
// ("experimentType") that's frequently unset. Falls back to showing a
// section whenever its underlying chart exists when designType is unknown.
//
// main_effects/significance are correlation/auto-test based, so they're
// shown for "monte_carlo" too; parameter_ranking (grouped ANOVA) needs
// discrete levels and stays factorial-only.
export function deriveDesignInfo(chartData, metadata, experimentType) {
  const design = chartData._design || {};
  const designType = design.type || null;
  const designMeta = design.meta || {};
  const degenerate = design.degenerate || metadata.degenerate || {};
  const chartErrors = design.chart_errors || [];

  const responseVariable =
    design.response_variable || metadata.response_variable || "throughput";
  const responseMetric =
    design.response_metric || metadata.response_metric || "throughput";
  const responseVariableLabel =
    RESPONSE_VARIABLE_LABELS[responseVariable] || "Throughput";

  const showMonteCarloSection = designType
    ? ["monte_carlo", "mixed"].includes(designType)
    : true;
  const showFactorialSection = designType
    ? ["factorial", "factorial_partial", "mixed"].includes(designType)
    : true;
  const showParameterEffectsSection = designType
    ? ["factorial", "factorial_partial", "mixed", "monte_carlo"].includes(
        designType,
      )
    : true;

  return {
    design,
    designType,
    designMeta,
    degenerate,
    hasDegenerate: Object.keys(degenerate).length > 0,
    chartErrors,
    responseVariable,
    responseMetric,
    responseVariableLabel,
    showMonteCarloSection,
    showFactorialSection,
    showParameterEffectsSection,
    currentExperimentType: metadata.experiment_type || experimentType || "None",
  };
}
